<app-carousel-flat
  [heading]="'Organizers'"
  [items]="organizations"
  [link]="'/browse-organizations'"
  [itemsPerSlide]="itemsPerSlide"
  [showIndicators]="isMobile"
  [showPagination]="!isMobile"
>
  <ng-template let-item="item">
    <app-organization [organization]="item"> </app-organization>
  </ng-template>
</app-carousel-flat>
